import React, { useEffect, useRef } from "react";
import {
  getPowerWallOptions,
  getExpansionPackCashPrice,
  shouldRenderPowerWall,
  getOrSpsAdderRatePerWatt,
  getOrSpsAdderTotalCash,
} from "../../helper-functions/adders";
import checkmark from "../../../../assets/images/checkmark.svg";


const AdderMenu = ({
  systemSize,
  systemSizeAC,
  // State and Utility Flags
  nest,
  nestAdder,
  blackFriday,
  ionRebate,
  miscCash,
  military,
  reRoof,
  preferredUtility,
  utilityLocation,
  cpsRebate,
  austinRebate,
  sustainable,
  militaryCap,
  dealerFee,
  battery10Amount,
  hasRec,
  miscCashAmount,
  miscCashNotes,
  loanA,
  critterGuard,
  msp,
  oregonLightreachPricingBump,
  setOregonLightreachPricingBump,
  utilityReview,
  securityToggled,
  salesTeam,
  battery10,
  powerWall,
  expansionPack,
  expansionPackAmount,
  setExpansionPackAmount,
  setExpansionPack,
  acCoupled,
  townhome,
  ballast,
  ballastAmount,
  treeTrim,
  treeTrimAmount,
  pSolar,
  pSolarAmount,
  // Customer Information
  customer, // { jurisdiction, roofAge }

  // Proposal Information
  proposal, // { groundMount, reroof }

  // Address Information
  state,

  // Callback Functions
  adderToggle,
  adderToggleBoolean,
  adderToggleNest,
  repAdderToggle,
  militaryAdderToggle,
  discountToggle,
  blkAdders,
  panelBonuses,
  reRoofAdderToggle,

  // Setters
  setNest,
  setNestAdder,
  setBlackFriday,
  setIonRebate,
  setMiscCash,
  setMiscCashAmount,
  setMiscCashNotes,
  setPowerWall,
  setBattery10Amount,
  setBatteryChanged,
  setMilitary,
  setHasRec,
  setCritterGuard,
  setMsp,
  setUtilityReview,
  setBattery10,
  setReRoof,
  setSecurityToggled,
  travelAdder = 2,
  travelAdderAmount,
  panelAmount,
  smallSystemAdderAmount,
  pvSystemAddOn,
  pvSystemAddOnAmount,
  permittingAdder,
  permittingAdderAmount,
  waterSoftener,
  setWaterSoftener,
  viewAdders = false,
  onAddersChangedForTpo,
}) => {
  const addersSnapshotBaselineRef = useRef(null);

  // When any adder value changes while the Adders tab is open, notify PropView so
  // opening Financing can require re-selecting TPO pricing (same as battery changes).
  useEffect(() => {
    if (!viewAdders || typeof onAddersChangedForTpo !== "function") {
      addersSnapshotBaselineRef.current = null;
      return;
    }
    const snap = JSON.stringify({
      acCoupled,
      expansionPack,
      expansionPackAmount,
      battery10,
      nest,
      nestAdder,
      blackFriday,
      ionRebate,
      miscCash,
      powerWall,
      military,
      reRoof,
      preferredUtility,
      cpsRebate,
      austinRebate,
      sustainable,
      battery10Amount,
      hasRec,
      miscCashAmount,
      miscCashNotes,
      critterGuard,
      msp,
      oregonLightreachPricingBump,
      securityToggled,
      utilityReview,
      townhome,
      ballast,
      ballastAmount,
      treeTrim,
      treeTrimAmount,
      pSolar,
      pSolarAmount,
      travelAdder,
      travelAdderAmount,
      smallSystemAdderAmount,
      pvSystemAddOn,
      pvSystemAddOnAmount,
      permittingAdder,
      permittingAdderAmount,
      waterSoftener,
      dealerFee,
    });

    if (addersSnapshotBaselineRef.current === null) {
      addersSnapshotBaselineRef.current = snap;
      return;
    }
    if (addersSnapshotBaselineRef.current !== snap) {
      addersSnapshotBaselineRef.current = snap;
      onAddersChangedForTpo();
    }
  }, [
    viewAdders,
    onAddersChangedForTpo,
    acCoupled,
    expansionPack,
    expansionPackAmount,
    battery10,
    nest,
    nestAdder,
    blackFriday,
    ionRebate,
    miscCash,
    powerWall,
    military,
    reRoof,
    preferredUtility,
    cpsRebate,
    austinRebate,
    sustainable,
    battery10Amount,
    hasRec,
    miscCashAmount,
    miscCashNotes,
    critterGuard,
    msp,
    oregonLightreachPricingBump,
    securityToggled,
    utilityReview,
    townhome,
    ballast,
    ballastAmount,
    treeTrim,
    treeTrimAmount,
    pSolar,
    pSolarAmount,
    travelAdder,
    travelAdderAmount,
    smallSystemAdderAmount,
    pvSystemAddOn,
    pvSystemAddOnAmount,
    permittingAdder,
    permittingAdderAmount,
    waterSoftener,
    dealerFee,
  ]);

  const houstonTeams = [
    "HTX BLK Sales Team",
    "H-Town Sales Team",
    "HTX Sales Team",
    "Development Sales Team",
  ];

  // set default battery and expansion pack amounts
  useEffect(() => {
    // set default battery amount
    if (!battery10Amount) {
      const basePricing = getPowerWallOptions(state)[0].value;
      setBattery10Amount(basePricing / +dealerFee);
    }

    // set default expansion pack amount
    if (!expansionPackAmount) {
      const basePricing = getExpansionPackCashPrice(state);
      setExpansionPackAmount(basePricing / +dealerFee);
    }
  }, [battery10, state, loanA.isPpa, dealerFee]);

  return (
    <>
      <div className="container">
        <div className="row">
          <h3 className="menuFont">Adders</h3>
        </div>
        <div className="custContainer menu">
          <div className="row">
            <div className="menuBorder"></div>
          </div>
          <div className="row">
            <div className="col-sm">
              {/* SMART THERMOSTAT & BULBS ADDER */}
              <Adder
                label={"Smart Thermostat & Bulbs"}
                checked={nest}
                onClick={(e) => adderToggleNest(nest, setNest)}
              >
                <AdderSelect
                  label={"# of Thermostats"}
                  value={nest}
                  onChange={(e) => setNest(+e.target.value)}
                  options={[
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                  ]}
                  shouldRender={nest > 0}
                />
              </Adder>
              {/* BLACK FRIDAY ADDER */}
              <Adder
                label={"$250 Black Friday"}
                checked={blackFriday === 1}
                onClick={(e) => repAdderToggle(blackFriday, setBlackFriday, 1)}
                shouldRender={false}
              />
              {/* $500 CUSTOMER INCENTIVE ADDER */}
              <Adder
                label={"$500 Customer Incentive"}
                checked={ionRebate === 1}
                voided={+loanA.isPpa === 1}
                onClick={
                  +loanA.isPpa === 1
                    ? () => ""
                    : (e) => repAdderToggle(ionRebate, setIonRebate, 1)
                }
                shouldRender={
                  !["Virginia", "South Carolina", "Maryland"].includes(state) &&
                  (+cpsRebate === 1 || +austinRebate === 1 || +sustainable === 1
                    ? false
                    : true)
                }
              />
              {/* $500 REP INCENTIVE ADDER */}
              <Adder
                label={"$500 Rep Incentive"}
                checked={ionRebate === 2}
                voided={+loanA.isPpa === 1}
                onClick={
                  +loanA.isPpa === 1
                    ? () => ""
                    : () => repAdderToggle(ionRebate, setIonRebate, 2)
                }
                shouldRender={
                  !["Virginia", "South Carolina", "Maryland"].includes(state) &&
                  (+cpsRebate === 1 || +austinRebate === 1 || +sustainable === 1
                    ? false
                    : true)
                }
              />
              {/* MISC CASH ADDER */}
              <Adder
                label={"MISC Cash"}
                description={"(not for nest cash out)"}
                checked={miscCash}
                onClick={(e) => adderToggle(miscCash, setMiscCash)}
              >
                <AdderInput
                  label={"MISC Cash Amount"}
                  placeholder="MISC Cash Amount"
                  type="number"
                  onChange={(e) => setMiscCashAmount(e.target.value)}
                  shouldRender={!!+miscCash}
                />
                <AdderInput
                  label={"MISC Cash Notes"}
                  placeholder="MISC Cash Notes"
                  type="text"
                  onChange={(e) => setMiscCashNotes(e.target.value)}
                  shouldRender={!!+miscCash}
                />
              </Adder>
              {/* $500 SETTER CASH BONUS ADDER */}
              <Adder
                label={"Setter/Rep Cash Incentive"}
                checked={true}
                onClick={() => null}
                disabled={true}
                shouldRender={["Virginia", "South Carolina", "Maryland"].includes(state)}
              />
              <Adder
                label="Increase Lightreach Pricing by $0.01"
                checked={!!oregonLightreachPricingBump}
                onClick={() =>
                  setOregonLightreachPricingBump(!oregonLightreachPricingBump)
                }
                shouldRender={state === "Oregon"}
              />
              <Adder
                label="OR SPS Adder"
                description={`$${getOrSpsAdderRatePerWatt(state).toFixed(2)}/W — ${Math.round(
                  getOrSpsAdderTotalCash(state, systemSize)
                ).toLocaleString(undefined, {
                  style: "currency",
                  currency: "USD",
                })}`}
                checked={true}
                onClick={() => {}}
                disabled={true}
                shouldRender={state === "Oregon"}
              />
              <Adder
                label={`AC Coupled - ${(1500 / +dealerFee).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={acCoupled}
                onClick={() => null}
                disabled={true}
                shouldRender={acCoupled}
              />
              {/* TOWNHOME ADDER */}
              <Adder
                label="Townhome"
                checked={+townhome > 0}
                onClick={() => null}
                disabled={true}
                shouldRender={+townhome > 0}
              />
              {/* BALLAST ADDER */}
              <Adder
                label={`Ballast - ${(+ballastAmount).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={+ballast}
                onClick={() => null}
                disabled={true}
                shouldRender={+ballast > 0}
              />
              {/* TREE TRIM ADDER */}
              <Adder
                label={`Tree Trim Adder - ${(+treeTrimAmount).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={+treeTrim}
                onClick={(e) => null}
                disabled={true}
                shouldRender={+treeTrim > 0}
              />
              {/* POOL SOLAR ADDER */}
              <Adder
                label={`Pool Solar Adder - ${(+pSolarAmount).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={+pSolar}
                onClick={(e) => null}
                disabled={true}
                shouldRender={+pSolar > 0}
              />
              {/* TRAVEL ADDER */}
              <Adder
                label={`Travel Adder - ${(+travelAdderAmount).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={+travelAdder > 0}
                onClick={(e) => null}
                disabled={true}
                shouldRender={+travelAdder > 0}
              />
              {/* PERMITTING ADDER */}
              <Adder
                label={`Permitting Adder = ${(
                  permittingAdderAmount * systemSize
                ).toLocaleString(undefined, {
                  style: "currency",
                  currency: "USD",
                })}`}
                checked={permittingAdder > 0}
                onClick={(e) => null}
                disabled={true}
                shouldRender={permittingAdder > 0}
              />
              {/* SMALL SYSTEM ADDER */}
              <Adder
                label={`Small System Adder - ${(+smallSystemAdderAmount).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={+panelAmount < 10}
                onClick={(e) => null}
                disabled={true}
                shouldRender={+panelAmount < 10}
              />
              {/* GROUND MOUNT ADDER */}
              <Adder
                label="Ground Mount"
                checked={+proposal.groundMount === 1}
                onClick={(e) => null}
                shouldRender={+proposal.groundMount === 1}
              />
              {/* UTILITY REVIEW ADDER */}
              <Adder
                label="Utility Review"
                checked={+utilityReview}
                onClick={(e) =>
                  adderToggleBoolean(utilityReview, setUtilityReview)
                }
                shouldRender={state === "New Mexico"}
              />
              {/* UPFRONT SREC ADDER */}
              <Adder
                label="Upfront SREC"
                checked={hasRec}
                onClick={(e) => adderToggle(hasRec, setHasRec)}
                shouldRender={state === "Virginia" || state === "Ohio" || state === "Illinois"}
              />
            </div>
            <div className="col">
              {/* CRITTER GUARD ADDER */}
              <Adder
                label="Critter Guard"
                checked={+critterGuard === 1}
                onClick={
                  customer.jurisdiction === "Firestone, CO"
                    ? () => ""
                    : () => {
                        setCritterGuard(critterGuard === 1 ? 0 : 1);
                      }
                }
              />
              {/* ELECTRICAL SERVICE CHARGE — hidden in Oregon (use Lightreach pricing bump instead). */}
              <Adder
                label="Electrical Service Charge"
                checked={msp}
                onClick={(e) => {
                  adderToggle(msp, setMsp);
                }}
                shouldRender={state !== "Oregon"}
              />
              {/* POWERWALL/BATTERY ADDER */}
              <Adder
                label="Tesla PowerWall 3 Battery"
                checked={+battery10 > 10 && battery10 < 20}
                onClick={(e) => {
                  if (battery10 < 11 || battery10 > 20) {
                    setPowerWall(1);
                    setBattery10(11);
                    const basePricing = getPowerWallOptions(state)[0].value;
                    setBattery10Amount(basePricing / +dealerFee);
                  } else {
                    setPowerWall(0);
                    setBattery10(0);
                    setBattery10Amount(0);
                    setExpansionPack(0);
                  }
                }}
                shouldRender={shouldRenderPowerWall(customer.territory)}
              >
                <AdderSelect
                  label={"Amount"}
                  value={+battery10Amount}
                  onChange={(e) => {
                    setBattery10Amount(+e.target.value);
                    setBatteryChanged(true);
                  }}
                  options={getPowerWallOptions(state, +loanA.isPpa === 1).map(
                    (o) => ({
                      label: o.label,
                      value: +(o.value / +dealerFee).toFixed(0),
                    })
                  )}
                  shouldRender={+battery10 > 10}
                />
                <AdderSelect
                  label={"Quantity"}
                  value={+battery10 - 10}
                  onChange={(e) => {
                    setBattery10(10 + +e.target.value);
                    setBatteryChanged(true);
                  }}
                  options={[
                    { label: "1", value: 1, disabled: systemSizeAC >= 10 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                    { label: "4", value: 4 },
                    { label: "5", value: 5 },
                  ]}
                  shouldRender={+battery10 > 10}
                />
                <AdderSelect
                  label={"Expansion Packs"}
                  value={+expansionPack}
                  onChange={(e) => {
                    setExpansionPack(+e.target.value);
                  }}
                  options={[
                    {
                      label: "0",
                      value: 0,
                    },
                    {
                      label: "1",
                      value: 1,
                    },
                    {
                      label: "2",
                      value: 2,
                    },
                    {
                      label: "3",
                      value: 3,
                    },
                    {
                      label: "4",
                      value: 4,
                      disabled: battery10 < 12,
                    },
                    {
                      label: "5",
                      value: 5,
                      disabled: battery10 < 12,
                    },
                    {
                      label: "6",
                      value: 6,
                      disabled: battery10 < 12,
                    },
                    {
                      label: "7",
                      value: 7,
                      disabled: battery10 < 13,
                    },
                    {
                      label: "8",
                      value: 8,
                      disabled: battery10 < 13,
                    },
                    {
                      label: "9",
                      value: 9,
                      disabled: battery10 < 13,
                    },
                    {
                      label: "10",
                      value: 10,
                      disabled: battery10 < 14,
                    },
                    {
                      label: "11",
                      value: 11,
                      disabled: battery10 < 14,
                    },
                    {
                      label: "12",
                      value: 12,
                      disabled: battery10 < 14,
                    },
                    {
                      label: "13",
                      value: 13,
                      disabled: battery10 < 15,
                    },
                    {
                      label: "14",
                      value: 14,
                      disabled: battery10 < 15,
                    },
                    {
                      label: "15",
                      value: 15,
                      disabled: battery10 < 15,
                    },
                  ]}
                  shouldRender={+battery10 > 10}
                />
              </Adder>
              {/* MILITARY DISCOUNT ADDER */}
              <Adder
                label="Military Discount"
                checked={military > 0}
                onClick={(e) => militaryAdderToggle(military, setMilitary)}
              >
                <AdderSelect
                  label={"Amount"}
                  value={military}
                  onChange={(e) => setMilitary(+e.target.value)}
                  options={[
                    { label: "$250", value: militaryCap ? 3 : 1 },
                    { label: "$500", value: militaryCap ? 4 : 2 },
                  ]}
                  shouldRender={military > 0}
                />
              </Adder>
              {/* WATER SOFTENER ADDER */}
              <Adder
                label="Water Softener"
                checked={waterSoftener > 0}
                onClick={(e) => setWaterSoftener(waterSoftener === 1 ? 0 : 1)}
                shouldRender={salesTeam === "STX Sales Team"}
              />
              {/* PREFERRED UTILITY DISCOUNT ADDER */}
              <Adder
                label="Preferred Utility Discount"
                checked={preferredUtility}
                onClick={(e) => discountToggle("preferred")}
              />
              {blkAdders()}
              {panelBonuses()}
              {/* RE-ROOF ADDER */}
              <Adder
                label="Re-roof"
                checked={reRoof}
                onClick={(e) => reRoofAdderToggle(reRoof, setReRoof)}
                shouldRender={
                  customer.roofAge === "15 to 20 years" ||
                  customer.roofAge === "20+ years" ||
                  proposal.reroof > 0
                }
              />
              {/* SECURITY ADDER */}
              <Adder
                label="Security"
                checked={securityToggled}
                onClick={(e) => setSecurityToggled(!securityToggled)}
                shouldRender={houstonTeams.includes(salesTeam)}
              />
              <Adder
                label={`PV System Add-On - ${(+pvSystemAddOnAmount).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )}`}
                checked={+pvSystemAddOn > 0}
                onClick={(e) =>
                  console.log("pvSystemAddOnAmount", pvSystemAddOnAmount)
                }
                disabled={true}
                shouldRender={+pvSystemAddOn > 0}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

/**
 * Adder component that renders a checkbox with a label and description.
 *
 * @description
 * - The Adder component is a reusable component that displays a checkbox with a label and an optional description.
 * - When children are provided, they will be rendered below the checkbox.
 *
 * @example
 * <Adder
 *  label="Example Label"
 *  description="Example Description"
 *  checked={true}
 *  onClick={() => console.log('Checkbox clicked')}
 *  disabled={false}
 *  voided={false}
 *  shouldRender={true}
 * >
 *  <AdderInput label="Example Input" placeholder="Enter something" />
 * </Adder>
 */
function Adder({
  label,
  description,
  checked,
  onClick,
  disabled,
  voided,
  shouldRender = true,
  children,
}) {
  const checkBoxClassNames = ["checkBox"];
  const labelClassNames = ["savingsText", "modals", "add"];

  if (checked) {
    checkBoxClassNames.push("checked");
  }

  if (disabled) {
    checkBoxClassNames.push("checked-grayed");
  }

  if (voided) {
    labelClassNames.push("void");
  }

  if (shouldRender === false) {
    return null;
  }

  return (
    <>
      <div
        className="row"
        onClick={(e) => {
          if (disabled || voided) {
            return;
          }
          onClick({
            target: {
              checked: !checked,
            },
          });
        }}
      >
        <div className="col-lg-1 col-2">
          <div className={checkBoxClassNames.join(" ")}>
            <img alt="checkmark" src={checkmark}></img>
          </div>
        </div>
        <div className="col">
          <div className={labelClassNames.join(" ")}>
            {label}
            {description && (
              <>
                <br />
                <span>{description}</span>
              </>
            )}
          </div>
        </div>
      </div>
      {shouldRender && children}
    </>
  );
}

/**
 * AdderInput component that renders an input field with a label.
 *
 * @note This component should be used as a child of the Adder component.
 */
function AdderInput({
  label,
  placeholder,
  onChange,
  type = "text",
  shouldRender,
}) {
  if (shouldRender === false) {
    return null;
  }

  return (
    <div className="row">
      <div className="col">
        <div className="qualyText holders l">{label}</div>
        <input
          className="custInput qualy l"
          type={type}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

/**
 * AdderSelect component that renders a select dropdown with options.
 *
 * @note This component should be used as a child of the Adder component.
 */
function AdderSelect({ label, value, onChange, options, shouldRender }) {
  if (shouldRender === false) {
    return null;
  }
  return (
    <div className="row">
      <div className="col">
        <div className="qualyText holders l">{label}</div>
        <select className="custInput credit" value={value} onChange={onChange}>
          {options.map((option, index) => (
            <option
              key={index}
              value={option.value}
              disabled={option.disabled ?? false}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

function AdderCheckbox({
  label,
  description,
  checked,
  onClick,
  disabled,
  voided,
  shouldRender = true,
}) {
  const checkBoxClassNames = ["checkBox"];
  const labelClassNames = ["savingsText", "modals", "add"];

  if (checked) {
    checkBoxClassNames.push("checked");
  }

  if (disabled) {
    checkBoxClassNames.push("checked-grayed");
  }

  if (voided) {
    labelClassNames.push("void");
  }

  if (shouldRender === false) {
    return null;
  }

  return (
    <>
      <div
        className="row"
        onClick={(e) => {
          if (disabled || voided) {
            return;
          }
          onClick(e);
        }}
      >
        <div className="col-lg-1 col-2">
          <div className={checkBoxClassNames.join(" ")}>
            <img src={checkmark}></img>
          </div>
        </div>
        <div className="col">
          <div className={labelClassNames.join(" ")}>
            {label}
            {description && (
              <>
                <br />
                <span>{description}</span>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AdderMenu;
